var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1274 23.75H30.8774V35.625H26.1274V23.75ZM26.125 38H30.875V42.75H26.125V38Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.699 9.97537C31.8725 8.41975 30.2622 7.45312 28.5 7.45312C26.7377 7.45312 25.1275 8.41975 24.301 9.97775L6.87325 42.9024C6.48652 43.6254 6.29496 44.4367 6.31745 45.2564C6.33994 46.076 6.57571 46.8756 7.0015 47.5764C7.42116 48.2803 8.01715 48.8626 8.73062 49.2657C9.44409 49.6689 10.2504 49.879 11.0699 49.8754H45.9301C47.6116 49.8754 49.134 49.0156 50.0009 47.5764C50.426 46.8754 50.6614 46.0759 50.6839 45.2564C50.7063 44.4369 50.5152 43.6256 50.1291 42.9024L32.699 9.97537ZM11.0699 45.1254L28.5 12.2008L45.942 45.1254H11.0699Z",
    fill: "#FF4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPassword);
export default __webpack_public_path__ + "static/media/resetPassword.3d43093c6ac6aaf0363ba352f056b9ee.svg";
export { ForwardRef as ReactComponent };